var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-img',{attrs:{"fluid-grow":"","src":"/image/banner/招聘.jpg"}}),_c('div',{staticClass:"container-fulid"},[_c('div',{staticClass:"row no-gutters d-flex justify-content-center"},[_c('div',{staticClass:"col-12 col-lg-9"},[_c('recruitment',{staticClass:"mt-2",attrs:{"jobs":_vm.jobsList}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }